import type {
  MyOrderDetailsQuery,
  MyOrderFragment,
  UserFragment,
} from '@/graphql/saleor/api';
import { ACCOUNT_METADATA } from '@/lib/metadata/const';
import { getMetaValue } from '@/lib/metadata/helpers';
import { handlePhonePrefix } from '@/lib/phonePrefixes/helpers';
import type { CheckoutState } from '@/states/checkout';
export const getContactPhone = (
  order?:
    | CheckoutState<true>['checkout']
    | (MyOrderFragment & MyOrderDetailsQuery['order']),
  user?: Partial<UserFragment> | null,
) => {
  const phone = order?.billingAddress?.phone ?? order?.shippingAddress?.phone;
  if (!phone && user) {
    const userPhonePrefix = handlePhonePrefix(
      getMetaValue(user?.metadata ?? [], ACCOUNT_METADATA.phonePrefix) ?? '',
    );
    const userPhoneNumber = getMetaValue(
      user?.metadata ?? [],
      ACCOUNT_METADATA.phone,
    );

    const userPhone = `${userPhonePrefix}${userPhoneNumber}`;

    return userPhoneNumber !== '' && userPhonePrefix !== '' ? userPhone : phone;
  }

  return phone;
};
